document.addEventListener('DOMContentLoaded', function () {
  // Target only within each section instance
  document.querySelectorAll('.pop-page').forEach(function (popPage) {
    const triggerButton = popPage.querySelector('.pop-page__details--button');
    if (!triggerButton) return;

    triggerButton.addEventListener('click', function (e) {
      e.preventDefault();

      const id = triggerButton.getAttribute('data-id');
      const content = popPage.querySelector(`#page-content-${id}`);
      const exitButton = popPage.querySelector(`[data-close-button]`);
      const video = content?.querySelector('video');

      initModal(popPage, exitButton, video);
    });
  });

  function initModal(popPage, exitButton, video) {
    popPage.classList.remove('custom--is-inactive');
    popPage.classList.add('modal--is-active');
    document.body.classList.add('modal--is-open');

    const handleVideoPlay = () => {
      if (!video) return;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          video.muted = true;
          video.play().catch(err => console.log('Video play failed:', err));
        });
      }
    };
    const videoAttempt = setTimeout(handleVideoPlay, 300);

    function closeModal() {
      popPage.classList.add('custom--is-inactive');
      popPage.classList.remove('modal--is-active');
      document.body.classList.remove('modal--is-open');
      if (video) {
        clearTimeout(videoAttempt);
        video.pause();
        video.currentTime = 0;
      }
    }

    if (exitButton) {
      exitButton.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
      }, { once: true });
    }

    popPage.addEventListener('click', function (e) {
      if (e.target === popPage) {
        closeModal();
      }
    }, { once: true });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popPage.classList.contains('modal--is-active')) {
        closeModal();
      }
    }, { once: true });
  }
});
